
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipAlternativeRemote as ObiOwnShipAlternativeRemoteElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-alternative-remote.js';
 
 
 

 
 export const ObiOwnShipAlternativeRemote = createComponent({
   react: React,
   tagName: 'obi-own-ship-alternative-remote',
   elementClass: ObiOwnShipAlternativeRemoteElement,
   events: {
     
   }
  });
 
 